import React, { useEffect } from 'react'
import { loadLocation } from '~/state/modules/locations'
import { CircularProgress, Typography } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { updateLayout, loadLayout } from '~/state/modules/planimetry'
import { PaperContainer } from '~/views/shared'
import { LayoutForm } from '../LayoutForm'
import { ROUTES } from '~/views/routes'
import history from '~/config/history'
import { showSnackbarError, showSnackbarSuccess } from 'views/utils/snackbar'

export const LayoutUpdatePage = ({ match, onSuccess }) => {
  const dispatch = useDispatch()
  const { pendingUpdateLayout, layout, pendingLayout } = useSelector(
    (state) => state.planimetry
  )
  const { location } = useSelector((state) => state.locations)
  const { locationId, layoutId } = match.params

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setSubmitting(true)
      await dispatch(updateLayout(values))
      onSuccess(locationId)
      showSnackbarSuccess('Planimetria Actualizada!')
    } catch (error) {
      showSnackbarError(error)
    } finally {
      setSubmitting(false)
    }
  }

  const values = {
    LayoutId: layout?.Id,
    LayoutName: layout?.Name || '',
    ImageFile: layout?.ImageCdnUrl || null,
    LocationId: locationId
  }

  useEffect(() => {
    async function fetchData() {
      await dispatch(loadLocation(locationId))
      await dispatch(loadLayout(layoutId))
    }

    fetchData().then()
    // eslint-disable-next-line
  }, [match])

  return (
    <>
      <PaperContainer
        title={`Actualizar Planimetria de "${location ? location.Name : '-'}"`}>
        {pendingLayout ? (
          <>
            <CircularProgress size={24} style={{ marginRight: '1rem' }} />
            <Typography variant={'caption'}>Cargando...</Typography>
          </>
        ) : (
          <LayoutForm
            values={values}
            actionText='Actualizar'
            handleSubmit={handleSubmit}
            actionPending={pendingUpdateLayout}
            onCancel={() =>
              history.push(
                ROUTES.ADMIN.LOCATIONS.PLANIMETRY.INDEX.replace(
                  ':locationId',
                  locationId
                )
              )
            }
          />
        )}
      </PaperContainer>
    </>
  )
}

export default LayoutUpdatePage
